import React, {PropTypes} from 'react';
import {API, modeCheck} from '../../../settings.js';
import {ajaxGet} from '../../../helpers/apiData.js';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router-dom';

import ListItem from './ListItem';
import FavBtn from './FavBtn';
import CatCta from './CatCta';
import SmallCard from './SmallCard';
import Accordeon from './Accordeon';
import Error from '../../Error';
import LikeBtn from '../LikeBtn';
import PreLoader from "../../PreLoader";

import {imagesLoaded} from "../../../helpers/imagesLoadCheck.js";


class ItemDetail extends React.Component {
  static propTypes = {
    category: PropTypes.string,
    history: PropTypes.object,
    item: PropTypes.string,
    match: PropTypes.object,
    package: PropTypes.number,
    view_info: PropTypes.func,
    wine_slug: PropTypes.string,
    favsTotal: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      data: {
        gallery: [],
        extras: [],
        related_drink: [],
        sugested_food: [],
        alternative: [],
        like: 0,
        cta: {},
        status: '',
        unity: '',
        diet: null,
      },
      toggle: 'inactive',
      loading: 'loading',
      addthis: 'true',
      detail_width: 0,
      mode: modeCheck("mode"),
      favToggle: false
    };

    this.handleLoading = this.handleLoading.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.favsTotal = this.favsTotal.bind(this);
  }

  componentDidMount() {
    this.lang = this.props.match.params.lang;
    this.restId = this.props.match.params.restaurant;
    this.catSlug = this.props.category;
    this.itemSlug = this.props.item;

    ajaxGet(API + this.lang + '/api/' + this.restId + '/items/' + this.catSlug.split("-").pop() +
      '/' + this.itemSlug.split("-").pop() + '/', this);

    window.addEventListener("resize", this.updateDimensions);
    this.updateDimensions();

    const detailTitle = (<FormattedMessage id="detail_title">
      {(message) => <span>{message}</span>}
    </FormattedMessage>);

    // Sending view info to Restaurant.js to feed the Top and Bottom bars
    this.props.view_info(
      detailTitle,
      'detail',
      true
    );
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params !== nextProps.match.params) {
      let category = nextProps.category;
      let item = nextProps.item;

      ajaxGet(API + this.lang + '/api/' + this.restId + '/items/' + category.split("-").pop() +
        '/' + item.split("-").pop() + '/', this);

      this.setState({addthis: 'true'});
    }
  }

  //NEED THIS TO FORCE ADDTHIS TO LOAD
  componentDidUpdate(prevState) {
    // eslint-disable-next-line
    if (prevState.addthis !== this.state.addthis && typeof addthis.layers.refresh !== 'undefined') {
      // eslint-disable-next-line
      addthis.layers.refresh();
    }
    window.addEventListener("load", this.updateDimensions);

  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  updateDimensions() {

    let sideNavWidth = document.getElementById('sideNav').offsetWidth;

    if (window.innerWidth > 1024) {
      this.setState({detail_width: document.body.clientWidth - sideNavWidth});
    }
    else {
      this.setState({detail_width: document.body.clientWidth});
    }
  }


  typeCheck() {
    let listRelated = [];

    if (this.state.data.item_type === 'food' && this.props.wine_slug) {
      listRelated = this.state.data.related_drink.map((item) => {
        return (
          <SmallCard key={'drink-match-' + item.id} name={item.title}
                     price={item.price}
                     description={item.description} photo={item.photo} lang={this.lang}
                     slug={item.slug} rest={this.restId} pk={item.id} cat={item.category}
                     wineType={item.wine_type}/>
        );
      });

      listRelated.unshift(
        <FormattedMessage key="drinks-title" id="suggested_wines">
          {(message) => <h6>{message}</h6>}
        </FormattedMessage>
      );

      listRelated.push(
        <div className="link-all-area" key="drinks-link-all">
          <FormattedMessage id="drinks-link-all">
            {(message) =>
              <Link to={'/' + this.lang + '/' + this.restId + '/items/' + this.props.wine_slug}>{message}</Link>}
          </FormattedMessage>
        </div>
      );
    }
    else {
      listRelated = this.state.data.sugested_food && this.state.data.sugested_food.map((item) => {
        return (
          <SmallCard key={'related-match-' + item.pk} name={item.title}
                     price={item.price}
                     description={item.description} photo={item.photo} lang={this.lang}
                     slug={item.slug} rest={this.restId} pk={item.pk} cat={item.category}/>
        );
      });

      listRelated && listRelated.unshift(
        <FormattedMessage key="related-foods-title" id="related_dishes">
          {(message) => <h6>{message}</h6>}
        </FormattedMessage>
      );


    }
    return {listRelated};
  }

  /* DOES IT HAVE EXTRAS ? */
  checkExtras() {
    if (this.state.data.hasOwnProperty('extras') && this.state.data.extras.length > 0) {
      return (
        <div className="card">
          <Accordeon related={this.state.data.extras}/>
        </div>
      );
    }
    return null;
  }

  /* DOES THE RELATED CTA CATEGORY EXIST? */
  checkCta() {
    if (this.state.data.hasOwnProperty('cta') && this.state.data.cta && this.props.package === 1) {
      return (
        <div className="divider-cta">
          <CatCta lang={this.lang} restSlug={this.restId} cta={this.state.data.cta}/>
        </div>
      );
    }
    return null;
  }

  /* DOES IT HAVE RELATED ITEMS ? */

  // todo smallcard should have the map inside we just pass the objects to map, key prefix lang and restid
  checkAlternative() {
    if (this.state.data.hasOwnProperty('alternative') && this.state.data.alternative.length > 0) {
      let listAlternative = this.state.data.alternative.map((item) => {
        return (
          <SmallCard key={`related-match-` + item.pk} name={item.title} lang={this.lang}
                     price={item.price} description={item.description} photo={item.photo}
                     slug={item.slug} restaurant={this.restId} pk={item.pk} cat={item.category}/>
        );
      });

      return (
        <div className="suggested-area">
          <FormattedMessage id="related_products">
            {(message) => <h6>{message}</h6>}
          </FormattedMessage>
          {listAlternative}
        </div>
      );
    }
    return null;
  }

  handleLoading() {
    this.setState({
      loading: imagesLoaded(this.detail),
    });
  }

  favsTotal(total) {
    this.setState({
      favToggle: !this.state.favToggle
    });
    this.props.favsTotal(total);
  }

  renderDiets(){
    return this.state.data.diet.map(item => {
      return (
        <div key={item.slug} className='list-icons-item'>
           <span>{item.name}</span>
        </div>
      )
    })

  }
  render() {
    let width = {
      width: this.state.detail_width
    };

    // CHECKING FOR ERRORS FROM THE API
    if (this.state.data.status === "error") {
      return (
        <Error restaurant={this.restId} lang={this.lang}/>
      );
    }

    let relatedInfo = this.typeCheck();

    return (
      <div>
        <PreLoader loading={this.state.loading}/>

        <div className={'item-detail content-wrapper ' + this.state.loading} style={width} onLoad={this.handleLoading}>
          <div className="btn-wrapper">
            <button className="btn body-back-btn" onClick={this.props.history.goBack}/>
          </div>
          <div className="detail-half">
            <div className="card main-card" ref={(el) => {
              this.detail = el;
            }}>
              <ListItem name={this.state.data.title}
                        gallery={this.state.data.gallery[0]}
                        description={this.state.data.description}
                        price={this.state.data.price} likes={this.state.data.like}
                        restSlug={this.restId} catSlug={this.catSlug}
                        itemSlug={this.itemSlug} list="false"
                        region={this.state.data.wine_region}
                        type={this.state.data.wine_type} itemType={this.state.data.item_type}
                        loading={this.handleLoading} lang={this.lang} body={this.state.data.body}
                        sweetness={this.state.data.sweetness} pk={this.state.data.id} unit={this.state.data.unit}
              />
              <div className='list-icons'>
                {this.state.data.diet !== null ? this.renderDiets() : null}
              </div>

              <FavBtn itemType={this.state.data.item_type} pk={this.state.data.id} onClick={this.favsTotal}/>
              {this.state.mode !== 'kiosk' ?
                <div ref="addthis" className="addthis_inline_share_toolbox"/> : null
              }
              <LikeBtn likes={this.state.data.like} restSlug={this.state.restSlug} catSlug={this.catSlug}
                       itemSlug={this.itemSlug} lang={this.lang} itemType={this.state.data.item_type}/>
            </div>
            {this.checkExtras()}
          </div>

          <div className="detail-half">
            {/* DOES IT HAVE SUGGESTED ITEMS ? */}
            {relatedInfo.listRelated && relatedInfo.listRelated.length > 0 && this.props.package === 1 ?
              <div className="suggested-area">
                {relatedInfo.listRelated}
              </div>
              : null
            }

            {this.checkCta()}
            {this.checkAlternative()}
          </div>
        </div>
      </div>
    );

  }
}

export default ItemDetail;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/core/ItemDetail.js
 **/